import type { FC } from "react";

import { LuckyLogo } from "~/icons";

export type StripeProps = {
  title: string;
};
/**
 * @deprecated
 */
export const Stripe: FC<StripeProps> = ({ title }) => {
  return (
    <div className="flex flex-col gap-6 lg:flex lg:flex-row lg:justify-center items-center lg:gap-[42px] text-[20px] leading-7 font-semibold lg:text-[32px] lg:leading-[41px] py-8">
      <LuckyLogo viewBox="0 0 56 56" />
      <p>{title}</p>
      <LuckyLogo className="hidden lg:block" viewBox="0 0 56 56" />
    </div>
  );
};
